import { Flex } from "@mantine/core";
import { useParams } from "react-router-dom";

import { useCustomer } from "../../../api/hooks/customer/useCustomer.ts";
import Preloader from "../../../components/Preloader/Preloader.tsx";
import CompanyInfo from "./CompanyInfo/CompanyInfo.tsx";
import ContactInfo from "./ContactInfo/ContactInfo.tsx";

const ContactDataTab = () => {
  const { customerId } = useParams() as { customerId: string };

  const [{ data, fetching }] = useCustomer({ id: customerId });

  return (
    <>
      <Preloader loading={fetching} />
      {data?.customer && (
        <Flex direction="column" gap={{ base: 20, sm: 32 }}>
          <CompanyInfo customer={data.customer} loading={fetching} />
          <ContactInfo customer={data.customer} loading={fetching} />
        </Flex>
      )}
    </>
  );
};

export default ContactDataTab;
